import { render, staticRenderFns } from "./LandownerForm.vue?vue&type=template&id=2fa9e81c"
import script from "./LandownerForm.vue?vue&type=script&lang=js"
export * from "./LandownerForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports